'use client';

import R2Image from '@/components/ui/R2Image';
import RichText from '@/components/ui/RichText/RichText';
import BalancedContentSection from '@/components/sections/BalancedContentSection/BalancedContentSection';

interface MeetOurCoFoundersFirstSectionProps {
  mainImage?: string;
  heading: string;
  styles?: Record<string, string>;
  subStyles?: Record<string, string>;
  descStyles?: Record<string, string>;
  subtitle: string;
  description: string;
}

const DEFAULT_HEADING_STYLES = {
  h2: 'text-h2 font-bold text-heading-primary mb-4 text-center',
};

const DEFAULT_SUBTITLE_STYLES = {
  h3: 'text-h3 font-bold text-heading-primary',
  em: 'not-italic text-royal-900 font-bold text-body mb-2',
};

const DEFAULT_DESC_STYLES = {
  p: 'text-body text-text-body-dark mb-6',
};

const MeetOurCoFoundersFirstSection = ({
  mainImage,
  heading,
  styles,
  subStyles,
  descStyles,
  subtitle,
  description,
}: MeetOurCoFoundersFirstSectionProps) => {
  return (
    <BalancedContentSection
      containerClassName=""
      spacingClassName="py-0"
      data={{
        textPosition: 'right',
        imageRatio: 'lg:w-2/5',
        backgroundColor: 'bg-transparent',
      }}
      textRatioClassName="lg:w-[55%]"
      gapClassName="gap-8 xl:gap-10"
      mediaContent={
        <div className="relative h-112.5 w-full">
          {mainImage && (
            <R2Image
              path={mainImage}
              alt={mainImage}
              className="rounded-xl object-cover object-center shadow-lg"
              sizes="(min-width: 1024px) 50vw, 100vw"
            />
          )}
        </div>
      }
      textContent={
        <div className="flex flex-col items-start space-y-2">
          <RichText styles={styles || DEFAULT_HEADING_STYLES}>
            {heading}
          </RichText>
          <div>
            <RichText styles={subStyles || DEFAULT_SUBTITLE_STYLES}>
              {subtitle}
            </RichText>
          </div>
          <RichText styles={descStyles || DEFAULT_DESC_STYLES}>
            {description}
          </RichText>
        </div>
      }
    />
  );
};

export default MeetOurCoFoundersFirstSection;
